export enum RegionTimeType {
  HO_SERVICE = 'HOService',
}
